//#region redux
import { useDispatch } from "react-redux";
import { wintSalaryDeviationsSubmitted } from "store/actions/salaryDeviationsActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { WintDeviationTodoFooterProps } from "models/propTypes/wintSalaryPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelWintSalaryReport } from "wint-api-client/dist/types";
//#endregion
//#region components
import { PageFooter } from "components/common";
import { useWintSalaryService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const WintDeviationTodoFooter: React.FC<WintDeviationTodoFooterProps> = (props) => {
  const { selectedRows, yearMonth, reloadHandler } = props;
  const { approveSalaryMonth } = useWintSalaryService();

  const dispatch = useDispatch();

  const onDeviationApprove = async () => {
    const reportData: WintSuperkollAPIModelWintSalaryReport.SalaryApprovalData = {
      yearAndMonth: yearMonth,
      personIds: selectedRows.map((row) => row.personId),
    };

    return await approveSalaryMonth(reportData);
  };

  const onApproveSuccess = () => {
    reloadHandler(() => dispatch(wintSalaryDeviationsSubmitted(0)));
  };

  return (
    <PageFooter
      actions={[
        {
          text: `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Approve)}${
            selectedRows.length > 0 ? ` (${selectedRows.length})` : ""
          }`,
          onClick: onDeviationApprove,
          type: StyleEnums.DisplayType.Success,
          successMessage: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.TimeReporting.SubmitTodoSuccessMessage
          ),
          isDisabled: selectedRows.length === 0,
          onActionSuccess: onApproveSuccess,
        },
      ]}
    />
  );
};

export default WintDeviationTodoFooter;
